import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../../utils/api-client';
import {OntologyTreeResponse} from '../interface';

function getTreeStructureRequest(accession: string, isCurrentDocOnly: boolean, anchorEl?: string) {
    return apiClient.post<OntologyTreeResponse>({
        path: 'editor-documents-service/api/trees',
        parameters: {
            accession,
            includeExternal: !isCurrentDocOnly,
            showPathToNodeId: anchorEl
        }
    });
}

interface Props {
    accession: string;
    isCurrentDocOnly: boolean;
    shouldRefetchFrequently?: boolean;
    anchorEl?: string;
}

export function useTreeStructureQuery({
    accession,
    isCurrentDocOnly,
    shouldRefetchFrequently,
    anchorEl
}: Props) {
    return useQuery({
        queryKey: ['ontology-tree-structure', accession, isCurrentDocOnly, anchorEl],
        queryFn: () => getTreeStructureRequest(accession, isCurrentDocOnly, anchorEl),
        refetchInterval: shouldRefetchFrequently ? 3000 : undefined
    });
}
